import * as React from "react";
import {cx}       from "emotion";

import "./upload-button.scss";

import {Link,
        makeChain} from "@Common/react/cst2";
import {UseRef}    from "@Common/react/use-ref";
import {Types}     from "@Common/types";


export const UploadButton = ({
    buttonText             = "Browse",
    statusText             = "Uploading {%}",
    uploadProgressPercent,
    acceptedTypes          = "*", // provide a comma-separate list of mime types (eg: image/jpeg, image/*) or file extensions (eg: .jpg, .jpeg) to restrict file selection by type
    buttonRef,
    onUpload,
    allowMultipleFiles     = false,
}:{
    buttonText            ?: string,
    statusText            ?: string,
    uploadProgressPercent  : number,
    acceptedTypes         ?: string,
    buttonRef             ?: Types.Common.React.UseRef.UseRefNext,
    onUpload               : (e:React.ChangeEvent<HTMLInputElement>) => void,
    allowMultipleFiles    ?: boolean,
}) => (

    makeChain<JSX.Element>()

    // create the upload input ref hook
    .then("uploadRef", (_, next:Link<JSX.Element, Types.Common.React.UseRef.UseRefNext>) => UseRef({next}))

    // set in progress status
    .then("isInProgress", (_, next:Link<JSX.Element, boolean>) => next(uploadProgressPercent !== 0))

    // set the button text
    .then("buttonContent", ({isInProgress}, next:Link<JSX.Element, string>) => {
        let text = buttonText;
        if (isInProgress) {
            if (uploadProgressPercent < 0) text = "Preparing Upload";
            else if (uploadProgressPercent === 100) text = "Processing Upload";
            else text = statusText.replace("{%}", `${Math.round(uploadProgressPercent)}%`);
        }
        return next(text);
    })

    // render the button
    .then(({uploadRef, isInProgress, buttonContent}) => <>
        <button className={cx("upload-button-dt5", isInProgress && "metering")}
            ref={ref => buttonRef && buttonRef.set(ref)}
            xd-qa-type="button" xd-qa-name="Browse"
            onClick={() => {uploadRef.get().click()}}
        >
            <span>{buttonContent}</span>
            {isInProgress && uploadProgressPercent >= 0 && (
            <div className="meter"
                style={{width: (uploadProgressPercent) ? `${uploadProgressPercent}%` : "100%"}}
            />
            )}
        </button>
        <input type="file"
            id="fileUpload"
            ref={ref => uploadRef.set(ref)}
            style={{display: "none"}}
            xd-qa-type="file_input" xd-qa-name="Fileupload"
            onChange={onUpload}
            accept={acceptedTypes}
            multiple={allowMultipleFiles}
        />
    </>)

    .run()

);
